import { useEffect, useState } from 'react'
import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps'
import { useDispatch, useSelector } from 'react-redux'
// DO NOT delete this import
import { geoPatterson } from 'd3-geo-projection'

import MapCountries from './MapCountries'
import MapCountryModal from './MapCountryModal'

import { getMap } from '../../../routing/fetchingfunction/dashboard/dashboard.action'
import { selectMapData } from '../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { useCountries } from '../../../hooks'

import getMarkerCoordinates from '../../../helpers/getMarkerCoordinates'

const Map = () => {
  const dispatch = useDispatch()

  const mapData = useSelector(selectMapData)

  const [studentsByCountry, setStudentsByCountry] = useState([])
  const [geographiesData, setGeographiesData] = useState([])
  const [selectedCountry, setSelectedCountry] = useState(null)

  const { countries } = useCountries()

  const handleClickCountry = (id) => {
    setTimeout(() => {
      if (selectedCountry !== id) {
        setTimeout(() => {
          setSelectedCountry(id)
        }, 0)

        return null
      }

      if (selectedCountry) {
        return null
      }

      setSelectedCountry(id)
    }, 0)
  }

  const handleCloseCountry = () => {
    setSelectedCountry(null)
  }

  useEffect(() => {
    dispatch(getMap())
  }, [])

  useEffect(() => {
    if (
      mapData &&
      typeof mapData.students_by_country === 'object' &&
      mapData.students_by_country !== null &&
      countries.length
    ) {
      const students = []

      Object.entries(mapData.students_by_country).forEach(([key, value]) => {
        const country = countries.find((country) => country.iso_3166_1_a2 === key)

        if (country) {
          students.push({
            id: country.iso_3166_1_a3,
            ...value,
          })
        }
      })

      setStudentsByCountry(students)
    }
  }, [mapData, countries])

  return (
    <div className="min-h-[955px] w-full">
      <div className="relative w-full rounded-[10px] bg-[#FEEBDD] p-[24px] flex items-center justify-center flex-col">
        {selectedCountry && (
          <MapCountryModal
            students={
              studentsByCountry.find((country) => country.id === selectedCountry)?.students || []
            }
            country={countries.find((country) => country.iso_3166_1_a3 === selectedCountry)}
            onClose={handleCloseCountry}
          />
        )}

        <div className="flex items-center justify-center max-w-[1019px] h-[608px]">
          <ComposableMap
            projection="geoMercator"
            projectionConfig={{
              scale: 145,
              center: [0, 45],
            }}
            width={1019}
            height={608}
            className="w-full h-full"
          >
            <Geographies geography="/assets/json/map.json">
              {({ geographies }) => {
                if (!geographiesData.length) {
                  setTimeout(() => {
                    setGeographiesData(geographies)
                  }, 0)
                }

                return geographies.map((geo) => (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill="#FF9154"
                    stroke="#FEEBDD"
                    className="outline-none"
                  />
                ))
              }}
            </Geographies>

            {!!geographiesData.length &&
              studentsByCountry.map((country) => {
                const foundGeography = geographiesData.find(
                  (geography) => geography.id === country.id
                )

                if (!foundGeography) {
                  return null
                }

                const isActive = selectedCountry === country.id

                return (
                  <Marker
                    key={country.id}
                    coordinates={getMarkerCoordinates(foundGeography.geometry.coordinates)}
                    onClick={() => handleClickCountry(country.id)}
                    className="cursor-pointer"
                  >
                    {isActive ? (
                      <>
                        <circle r={15} fill="white" fillOpacity="0.1" />
                        <circle r={8} fill="white" />
                        <circle r={3} fill="#12B76A" />
                      </>
                    ) : (
                      <>
                        <circle r={10} fill="white" fillOpacity="0" />
                        <circle r={4} fill="#12B76A" />
                      </>
                    )}
                  </Marker>
                )
              })}
          </ComposableMap>
        </div>

        <MapCountries studentsByCountry={studentsByCountry} countries={countries} />
      </div>
    </div>
  )
}

export default Map
